import Vue from 'vue'
import noty from '@/plugins/noty'
import EventBus from '@/lib/event-bus'
import store from '@/store'
import lstore from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import ActivitySummaryPlugin from 'vue-components/activity-summary'
import hubspotLogo from '@/assets/img/hubspot.svg'
import pipedriveLogo from '@/assets/img/pipedrive.png'
import copperLogo from '@/assets/img/copper.png'
import closeLogo from '@/assets/img/close.svg'
import bullhornLogo from '@/assets/img/bullhorn.svg'

Vue.use(ActivitySummaryPlugin, {
  store,
  noty,
  EventBus,
  jiminnyHost,
  hubspotLogoUrl: hubspotLogo,
  pipedriveLogoUrl: pipedriveLogo,
  copperLogoUrl: copperLogo,
  closeLogoUrl: closeLogo,
  bullhornLogoUrl: bullhornLogo,
  getTeam () {
    return lstore.get('team')
  },
  getUser () {
    return lstore.get('user')
  },
  hostApp: 'extension-app'
})



// WEBPACK FOOTER //
// ./src/plugins/activity-summary.js